// extracted by mini-css-extract-plugin
module.exports = {"heading":"_3YFGB","image":"_1Cm-N","button":"_1gfiu","slider":"_3X2rS"};